<template>
	<div>
    <div class="dashboard__container pt-3">
      
      <Loader v-if="!event || !event.id" />
     	<transition name="fade">
		    <div class="dashboard__container--body pt-3" style="justify-content: space-evenly;" v-if="event && event.jobs && event.jobs.length > 0">
		    	<div class="dashboard__container--body--col mb-0" style="width:100%;">

			    	<div class="list">
			    		<h4>Create New Shift - Type: {{eventInfo.shiftType || 'Gig'}}</h4>
			    		<!-- <span class="caption mb-3">*You can enter these shift defaults just as before, then override them per person when you place them if needed.</span> -->
			    		<div class="mb-3">
	    					<label for="shiftName">Shift Title (ex: Night Shift Janitor):</label>
	    					<input type="text" v-model.trim="newShift.title" id="shiftName" required />
	    				</div>
	  					<div class="flex">
	  						<div v-if="eventInfo && eventInfo.jobs">
	  							<label for="day">Set Default Job for Shift:</label>
	  							<v-select
			              label="title" 
			              :options="eventInfo.jobs"
			              v-model="newShift.job"
			              style="min-width: 280px;"
			              >
			            </v-select>
			            <div class="mt-2 caption" v-if="newShift.job">
			          	Pay Rate: ${{newShift.job.rate}} | Bill Rate: ${{newShift.job.billRate}}
			          </div>
			          </div>
			          
	  						
	  						<div class="pl-3">
	  							<label for="staff">Total Staff Requested:</label>
		            	<input type="number" v-model.trim="newShift.staffReqested" id="staff" />
	  						</div>
	  						<div class="pl-3" v-if="(eventInfo && (!eventInfo.shiftType || eventInfo.shiftType == 'Gig'))">
	  							<label for="notification">Send New Shift Notification to Group:</label>
	  							<div>
		            	<input type="checkbox" v-model.trim="newShift.sendNotification" id="notification" />
		            	</div>
	  						</div>
	  					</div>
	  					<!-- <div class="flex mt-3">
	  						<div>
		  						<label for="day">Select Shift Type:</label>
	  							<v-select
			              label="title" 
			              :options="types"
			              v-model="newShift.type"
			              style="min-width: 280px;"
			              >
			            </v-select>
		            </div>
	  					</div> -->
	  					<div class="flex mt-3 flex-column" v-if="(eventInfo && (!eventInfo.shiftType || (eventInfo.shiftType == 'Event' || eventInfo.shiftType == 'Gig')))">
	  						<div class="flex mt-3">
		  						<button class="chipDark mr-2 mb-2" v-for="(item, index) in shiftDates" @click="removeDay(index)">{{item}} <i class="fa-regular fa-xmark"></i></button>
		  					</div>
		  					<div class="flex mb-3">
			  					<div v-if="event && event.days">
			  							<label for="day">Select day:</label>
					            <input type="date" v-model.trim="newShiftDate" id="pickDate" @input="onPickDate()" />
				          </div>
				        </div>
		  					<div class="flex mb-3">
		  						<div>
			            <label for="start">Default Start Time:</label>
				            <input type="time" v-model.trim="newShift.start" id="start" />
				          </div>
				          <div class="pl-3">
				            <label for="end">Default End Time:</label>
				            <input type="time" v-model.trim="newShift.end" id="end" />
				          </div>
		  					</div>
	  					</div>
	  					<div class="flex mt-3 flex-column" v-if="(eventInfo && (eventInfo.shiftType && (eventInfo.shiftType == 'Permanent' || eventInfo.shiftType == 'Job')))">
	  						<div class="flex mt-3 flex-row">
		  						<div class="mr-5 flex align-center" style="width:80px;">
		  							<span class="caption strong">Start Date</span>
		  						</div>
		  						<div class="mr-5">
		  							<label for="start">Date:</label>
				            <input type="date" v-model.trim="newShift.startDate" id="start" />
		  						</div>
		  					</div>
	  						<div class="flex mt-3 flex-row">
		  						<div class="mr-5 flex align-center" style="width:80px;">
		  							<span class="caption strong">Sunday</span>
		  						</div>
		  						<div class="mr-5">
		  							<label for="start">Start Time:</label>
				            <input type="time" v-model.trim="newShift.sundayStart" id="start" />
		  						</div>
		  						<div class="mr-5">
		  							<label for="end">End Time:</label>
				            <input type="time" v-model.trim="newShift.sundayEnd" id="end" />
		  						</div>
		  					</div>
	  						<div class="flex mt-3 flex-row">
		  						<div class="mr-5 flex align-center" style="width:80px;">
		  							<span class="caption strong">Monday</span>
		  						</div>
		  						<div class="mr-5">
		  							<label for="start">Start Time:</label>
				            <input type="time" v-model.trim="newShift.mondayStart" id="start" />
		  						</div>
		  						<div class="mr-5">
		  							<label for="end">End Time:</label>
				            <input type="time" v-model.trim="newShift.mondayEnd" id="end" />
		  						</div>
		  					</div>
		  					<div class="flex mt-3">
		  						<div class="flex align-center mr-5" style="width:80px;">
		  							<span class="caption strong">Tuesday</span>
		  						</div>
		  						<div class="mr-5">
		  							<label for="start">Start Time:</label>
				            <input type="time" v-model.trim="newShift.tuesdayStart" id="start" />
		  						</div>
		  						<div class="mr-5">
		  							<label for="end">End Time:</label>
				            <input type="time" v-model.trim="newShift.tuesdayEnd" id="end" />
		  						</div>
		  					</div>
		  					<div class="flex mt-3">
		  						<div class="flex align-center mr-5" style="width:80px;">
		  							<span class="caption strong">Wednesday</span>
		  						</div>
		  						<div class="mr-5">
		  							<label for="start">Start Time:</label>
				            <input type="time" v-model.trim="newShift.wednesdayStart" id="start" />
		  						</div>
		  						<div class="mr-5">
		  							<label for="end">End Time:</label>
				            <input type="time" v-model.trim="newShift.wednesdayEnd" id="end" />
		  						</div>
		  					</div>
		  					<div class="flex mt-3">
		  						<div class="flex align-center mr-5" style="width:80px;">
		  							<span class="caption strong">Thursday</span>
		  						</div>
		  						<div class="mr-5">
		  							<label for="start">Start Time:</label>
				            <input type="time" v-model.trim="newShift.thursdayStart" id="start" />
		  						</div>
		  						<div class="mr-5">
		  							<label for="end">End Time:</label>
				            <input type="time" v-model.trim="newShift.thursdayEnd" id="end" />
		  						</div>
		  					</div>
		  					<div class="flex mt-3">
		  						<div class="flex align-center mr-5" style="width:80px;">
		  							<span class="caption strong">Friday</span>
		  						</div>
		  						<div class="mr-5">
		  							<label for="start">Start Time:</label>
				            <input type="time" v-model.trim="newShift.fridayStart" id="start" />
		  						</div>
		  						<div class="mr-5">
		  							<label for="end">End Time:</label>
				            <input type="time" v-model.trim="newShift.fridayEnd" id="end" />
		  						</div>
		  					</div>
		  					<div class="flex mt-3">
		  						<div class="flex align-center mr-5" style="width:80px;">
		  							<span class="caption strong">Saturday</span>
		  						</div>
		  						<div class="mr-5">
		  							<label for="start">Start Time:</label>
				            <input type="time" v-model.trim="newShift.saturdayStart" id="start" />
		  						</div>
		  						<div class="mr-5">
		  							<label for="end">End Time:</label>
				            <input type="time" v-model.trim="newShift.saturdayEnd" id="end" />
		  						</div>
		  					</div>
	  					</div>
	  					

	  					<!-- <div class="mb-3 mt-5" style="max-width: 300px;">
	              <label for="rep">Required Certifications:</label>

	              <v-select
	                class="mt-2"
	                :options="newShift.job.certs"
	                v-model="newShift.job.certs"
	                multiple
	                >
	              </v-select>
	  					</div> -->

	  					<div class="mb-3">
		            <label for="details">Shift-Specific Details or Job Description:</label>
		            <textarea name="details" id="details" cols="30" rows="3" v-model.lazy="newShift.details" style="background: #efefef;"></textarea>
		          </div>

		          <div class="mb-3">
		            <label for="info">Shift Into to Email Staff:</label>
		            <textarea name="info" id="info" cols="30" rows="1" v-model.lazy="newShift.info" style="background: #efefef;"></textarea>
		          </div>
		          
		          <div v-if="eventInfo.shiftType == 'Gig'">
		          	<button :disabled="!newShift.staffReqested || !newShift.job.rate" class="btn btn__success mt-2" @click="addNewShift()">Add Shift</button>
		          </div>
		          <div v-if="eventInfo.shiftType == 'Job'">
		          	<button :disabled="!newShift.staffReqested || !newShift.job.rate" class="btn btn__success mt-2" @click="addNewPermanentShift()">Add Shift</button>
		          </div>
						</div>
					</div>
				</div>
		  </transition>
		  <hr>
		  <div class="dashboard__container--body">
        <Loader v-if="!eventShifts || eventShifts.length == 0" />
        <vue-good-table
            :columns="columns"
            :rows="eventShifts"
             styleClass="vgt-table condensed"
            :search-options="{
              enabled: false,
              placeholder: 'Search this table',
            }"
            :pagination-options="{
              enabled: true,
              mode: 'records',
              perPage: 25,
            }"
            
          >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'created'">
              <!-- <span v-if="props.row.created">{{formatDate(props.row.created)}}</span> -->
            </span>
            <span v-else-if="props.column.field == 'day'">
            	<span v-if="props.row.type == 'Permanent' || props.row.type == 'Job'">
            		
            	</span>
            	<span v-else>
            		{{props.row.day}}
            	</span>
            </span>
            <span v-else-if="props.column.field == 'visible'">
              <i class="fa-solid fa-check" v-if="props.row.visible" style="color:green;"></i>
            </span>
            <span v-else-if="props.column.field == 'startTime'">
            	{{formatAMPM(props.row.startTime)}}
            </span>
            <span v-else-if="props.column.field == 'endTime'">
            	{{formatAMPM(props.row.endTime)}}
            </span>
        
            <span v-else-if="props.column.field == 'edit'">
            	<router-link :to="`/orders/` + eventInfo.id + `/shifts/` + props.row.id">
            		<button class="btn btn__small btn__outlined">Edit</button>
            	</router-link>
            </span>
            <span v-else-if="props.column.field == 'link'">
            	<router-link :to="`/orders/` + eventInfo.id + `/shifts/` + props.row.id + `/placement`">
            		<button class="btn btn__small btn__primary">Placements</button>
            	</router-link>
            </span>

            <span v-else-if="props.column.field == 'form'">
            	<a :href="`https://jumpstaffing.com/form/` + props.row.id" target="_blank">
				          <button class="btn btn__small btn__outlined mr-3 mb-2">Web Form</button>
				        </a>
            </span>



            
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import Loader from '@/components/Loader.vue'
import ShiftNote from '@/components/Placements/ShiftNote.vue'
import router from '@/router'
const fb = require('../../firebaseConfig.js')
import * as moment from 'moment'

export default {
	props: ['eventInfo', 'eventShifts', 'eventShiftsDays'],
  name: 'eventShifts',
  // props: ['eventInfo'],
  
  components: {
    Loader,
    ShiftNote,
    // DatePicker 
  },
  data() {
    return {
    	newShiftDate: "",
    	shiftDates: [],
      performingRequest: false,
      showNewNote: false,
      newShift: {
      	sendNotification: false,
      },
      newName: '',
      types: ['Gig', 'Job'],
      // certs: ['Food Hander', 'Alcohol Awareness', 'Fork Lift', 'Scissor Lift'],
      columns: [
		      {
		        label: 'Day',
		        field: 'day',
		      },
		      {
		        label: '',
		        field: 'edit',
		        sortable: false,
		      },
		      {
		        label: '',
		        field: 'link',
		        sortable: false,
		      },
		      // {
		      //   label: 'Event',
		      //   field: 'event',
		      //   sortable: false,
		      // },
		      {
		        label: 'Title',
		        field: 'title',
		        sortable: false,
		      },
		      {
		        label: 'Type',
		        field: 'type',
		      },
		      // {
		      //   label: 'type',
		      //   field: 'workerType',
		      // },
		      {
		        label: 'Location',
		        field: 'location',
		        sortable: false,
		      },
		      {
		        label: 'Position',
		        field: 'position.title',
		      },
		      {
		        label: 'Staff',
		        field: 'staff',
		      },
		      {
		        label: 'Form',
		        field: 'form',
		      },
		      // {
		      //   label: 'Start Time',
		      //   field: 'startTime',
		      // },
		      // {
		      //   label: 'End Time',
		      //   field: 'endTime',
		      // },
		  ],
    }
  },
  computed: {
    ...mapState(['userProfile', 'currentUser']),
    event() {
      return this.eventInfo
    },
    eventId() {
    	return this.eventInfo.id
    },
    groupIDs() {
    	let idsArray = []
    	this.event.groups.forEach(group => {
    		idsArray.push(group.id)
    	})
    	return idsArray
    }
  },
  methods: {
  	removeDay(index) {
  		this.shiftDates.splice(index, 1);
  	},
  	onPickDate() {
  		this.shiftDates.push(this.newShiftDate)
  		this.newShiftDate = ''
  	},
  	// onRowClick(params) {
  	// 	let url = `/orders/` + this.$route.params.id + `/shifts/` + params.row.id
    //   router.push(url)
  	// },
  	// goBack() {
    //   router.go(-1)
    // },
    // updateJob() {
    //   console.log(event)
    //   let event = this.event
    //   this.$store.dispatch('updateEvent', event)
    // },
    // updateEvent(){
    //   let event = this.event
    //   console.log(event)
    //   this.$store.dispatch('updateEvent', event)
    // },
    // submitName() {
    // 	let event = this.event
    // 	this.$store.dispatch('updateEvent', event)
    // },
    addNewPermanentShift () {
  		let shift = {
        position: this.newShift.job || { title: null},
        // startTime: this.newShift.start || null,
        // endTime: this.newShift.end || null,
        name: this.newShift.job.title || null,
        title: this.newShift.title || null,
        certs: this.newShift.job.certs || null,
        // location: this.newShift.location || null,
        staff: this.newShift.staffReqested,
        eventId: this.event.id,
        event: this.event.title,
        eventInfo: this.event,
        minHours: this.event.minHours || 0,
        day: this.newShift.startDate,
        workerType: this.event.workerType || 'Contractor',
        groups: this.event.groups,
        groupIds: this.groupIDs,
        center: this.event.venue.center,
        location: this.event.venue.address.city + ', ' +  this.event.venue.address.state,
        venue: this.event.venue.title,
        venueId: this.event.venueId,
        address: this.event.venue.address,
        type: this.eventInfo.shiftType,
        sundayStart: this.newShift.sundayStart || null,
        mondayStart: this.newShift.mondayStart || null,
        tuesdayStart: this.newShift.tuesdayStart || null,
        wednesdayStart: this.newShift.wednesdayStart || null,
        thursdayStart: this.newShift.thursdayStart || null,
        fridayStart: this.newShift.fridayStart || null,
        saturdaydayStart: this.newShift.saturdaydayStart || null,
        sundayEnd: this.newShift.sundayEnd || null,
        mondayEnd: this.newShift.mondayEnd || null,
        tuesdayEnd: this.newShift.tuesdayEnd || null,
        wednesdayEnd: this.newShift.wednesdayEnd || null,
        thursdayEnd: this.newShift.thursdayEnd || null,
        fridayEnd: this.newShift.fridayEnd || null,
        saturdaydayEnd: this.newShift.saturdaydayEnd || null,
      }
      console.log(shift)
      fb.shiftsCollection.add(shift)
      .then(
        doc => {
        	console.log(doc.id)
        	fb.shiftsCollection.doc(doc.id).update({
        		id: doc.id, 
        	})
        }
      )
      this.$store.dispatch("getEventShifts", this.eventId)
      this.newShift = {}
    },
    addNewShift () {
    	this.shiftDates.forEach(date => {
    		let shift = {
	        position: this.newShift.job || { title: null},
	        startTime: this.newShift.start || null,
	        endTime: this.newShift.end || null,
	        name: this.newShift.title || null,
	        title: this.newShift.title || null,
	        certs: this.newShift.job.certs || null,
	        // location: this.newShift.location || null,
	        staff: this.newShift.staffReqested,
	        eventId: this.event.id,
	        event: this.event.title,
	        eventInfo: this.event,
	        minHours: this.event.minHours || 0,
	        day: date,
	        workerType: this.event.workerType || 'Contractor',
	        groups: this.event.groups,
	        groupIds: this.groupIDs,
	        center: this.event.venue.center,
	        location: this.event.venue.address.city + ', ' +  this.event.venue.address.state,
	        venue: this.event.venue.title,
	        venueId: this.event.venueId,
	        address: this.event.venue.address,
	        type: 'Event',
	        eventSlug: this.event.slug,
	        eventTitle: this.event.title,
	        eventStatus: this.event.status
	      }
	      console.log(shift)
	      fb.shiftsCollection.add(shift)
	      // .then(
	      //   doc => {
	      //   	fb.shiftsCollection.doc(doc.id).update({
	      //   		id: doc.id, 
	      //   	})
	      //   }
	      // )
    	})
      
      this.$store.dispatch("getEventShifts", this.eventId)
      // this.$store.dispatch("updateEventDays", {
      // 	event: this.eventId,
      // 	day: this.newShift.day
      // })
      this.newShift = {}
    },
    // updateShift(eventShift) {
    // 	this.performingRequest = true
    // 	eventShift.location = this.event.venue.address.city + ', ' +  this.event.venue.address.state;
    // 	eventShift.venue = this.event.venue.title;
    // 	eventShift.groupIds = this.groupIDs
    // 	this.$store.dispatch("updateEventShift", eventShift)
    // 	setTimeout(() => {
    //     this.performingRequest = false
    //   }, 1000)
    // },
    // showDeleteShift(eventShift) {
    // 	eventShift.showDelete = true
    // 	this.$store.dispatch("updateEventShift", eventShift)
    // },
    // cancelDeleteShift(eventShift) {
    // 	eventShift.showDelete = false
    // 	this.$store.dispatch("updateEventShift", eventShift)
    // },
    // deleteShift(eventShift) {
    //   console.log(eventShift)
    //   this.$store.dispatch("deleteShift", eventShift.id)
    // },
    formatAMPM(date) {
      if (typeof date === "string") {
        let [hours, minutes] = date.split(":");
        let ampm = "AM";

        if (Number(hours) >= 12) {
          hours = Number(hours) - 12;
          ampm = "PM";
        }

        return `${hours}:${minutes} ${ampm}`;

      } else if (date instanceof Date) {
        let hours = date.getHours();
        let minutes = date.getMinutes();

        let ampm = hours >= 12 ? "PM" : "AM";

        hours = hours % 12;
        hours = hours ? hours : 12;
        minutes = minutes < 10 ? "0" + minutes : minutes;

        let strTime = hours + ":" + minutes + " " + ampm;

        return strTime;
      }
      return date;
    },
  },
  beforeDestroy () {
  	this.performingRequest = null
  	delete this.performingRequest
  	this.newShift = null
  	delete this.newShift
  	this.columns = null
  	delete this.columns
  	this.newShiftDate = null
  	delete this.newShiftDate
  	this.shiftDates = null
  	delete this.shiftDates
  	this.newName = null
  	delete this.newName
  	// this.certs = null
  	// delete this.certs
  	this.types = null
  	delete this.types
  	delete this.formatAMPM
  	delete this.addNewShift
  	delete this.onPickDate
  	delete this.removeDay
  	// this.$store.dispatch("clearJobsState")
  	console.log(this)
  }
}
</script>
